/**
 * Set up raygun with the correct app version and name
 */
export const init = (APP_VERSION, APP_NAME, hasInit) => {
	if (window.GG && window.GG.Raygun && !hasInit) {
		hasInit = true;
		window.GG.Raygun.setVersion(APP_VERSION, APP_NAME);
	}
};

/**
 * the underlying raygun lib will not log an error
 * if the 'stack' is not available. In this scenario
 * we return a new Error
 * @param {Error} error
 * @returns {Error}
 */
export const checkError = error => {
	return (!error.stack || error instanceof TypeError) ? new Error(error.message) : error;
};

/**
 * Use this method to log handled exceptions in the app.
 * @param {error} error - an instance of the Error class
 * @param {object} customData - additional info
 * @summary the GG.Raygun script automatically takes care
 *          of 'unhandled' js errors
 */
export const logError = (error, customData = {}) => {
	if (window.GG && window.GG.Raygun) {
		window.GG.Raygun.send(checkError(error), customData);
	}
};



// WEBPACK FOOTER //
// ../~/dna-core/components/utils/js/vendor/raygun.js